import React, { useState, useEffect } from "react";
import { get } from "../../services/api";
// import "./PTMTeacherStyles.css";

function PtmScheduleTeacher() {
  const [teacherSchedules, setTeacherSchedules] = useState([]);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [groupedEvents, setGroupedEvents] = useState([]);

  const token = localStorage.getItem("token");
  const user = localStorage.getItem("userId");
  const centerId = localStorage.getItem("centerId");

  useEffect(() => {
    fetchTeacherSchedules();
  }, []);

  const fetchTeacherSchedules = async () => {
    try {
      setLoading(true);
      setError("");

      const data = await get(`PTM/Teacher/GetAllMySchedules/${user}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setTeacherSchedules(data || []);

      if (data && data.length > 0) {
        // Group events by PTM title
        const grouped = groupEventsByTitle(data);
        setGroupedEvents(grouped);
        setSelectedSchedule(data[0]);
      } else {
        setError("No PTM schedules assigned to you.");
      }
    } catch (error) {
      setError("Error fetching schedules: " + error.message);
      console.error("Error fetching schedules:", error);
    } finally {
      setLoading(false);
    }
  };

  // Group events by title and add numbering if duplicates exist
  const groupEventsByTitle = (schedules) => {
    const eventMap = {};

    schedules.forEach((schedule) => {
      const title = schedule.ptmTitle;
      if (!eventMap[title]) {
        eventMap[title] = [];
      }
      eventMap[title].push(schedule);
    });

    const grouped = [];
    Object.keys(eventMap).forEach((title) => {
      const events = eventMap[title];
      if (events.length === 1) {
        grouped.push({
          ...events[0],
          displayTitle: title,
        });
      } else {
        events.forEach((event, index) => {
          grouped.push({
            ...event,
            displayTitle: `${title} (${index + 1})`,
          });
        });
      }
    });

    return grouped;
  };

  const getSlotStatusBadge = (status) => {
    return status === "Booked" ? (
      <span className="badge bg-success">Booked</span>
    ) : (
      <span className="badge bg-light text-dark">Available</span>
    );
  };

  const getProgressColor = (percentage) => {
    if (percentage >= 80) return "bg-success";
    if (percentage >= 50) return "bg-warning";
    return "bg-info";
  };

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "500px" }}
      >
        <div className="text-center">
          <div className="spinner-border text-primary mb-3" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="text-muted">Loading schedules...</p>
        </div>
      </div>
    );
  }

  if (error && teacherSchedules.length === 0) {
    return (
      <div className="container-fluid py-4">
        <div className="alert alert-danger">
          <i className="bi bi-exclamation-triangle me-2"></i>
          {error}
        </div>
      </div>
    );
  }

  if (teacherSchedules.length === 0) {
    return (
      <div className="container-fluid py-4">
        <div className="alert alert-info">
          <i className="bi bi-info-circle me-2"></i>
          No PTM schedules assigned to you at this time.
        </div>
      </div>
    );
  }

  const bookedPercentage = selectedSchedule
    ? Math.round(
        (selectedSchedule.schedule.filter((s) => s.status === "Booked").length /
          selectedSchedule.schedule.length) *
          100
      )
    : 0;

  return (
    <div className="container-fluid py-4">
      <div className="row mb-4">
        <div className="col">
          <h2 className="mb-1">
            <i className="bi bi-calendar-week text-primary me-2"></i>
            My PTM Schedules
          </h2>
          <p className="text-muted">
            Manage your parent-teacher meeting appointments
          </p>
        </div>
      </div>

      <div className="row">
        {/* Sidebar - Event List */}
        <div className="col-lg-3 mb-4">
          <div className="card shadow-sm border-0">
            <div className="card-header bg-white border-0">
              <h5 className="mb-0">
                <i className="bi bi-list-ul me-2 text-primary"></i>
                Events
              </h5>
            </div>
            <div className="card-body p-2">
              <div className="list-group list-group-flush">
                {groupedEvents.map((schedule, index) => {
                  const bookedCount = schedule.schedule.filter(
                    (s) => s.status === "Booked"
                  ).length;
                  const totalCount = schedule.schedule.length;
                  const percentage = Math.round(
                    (bookedCount / totalCount) * 100
                  );

                  return (
                    <button
                      key={schedule.id}
                      className={`list-group-item list-group-item-action border-0 mb-2 rounded ${
                        selectedSchedule?.id === schedule.id
                          ? "active shadow-sm"
                          : ""
                      }`}
                      onClick={() => setSelectedSchedule(schedule)}
                      style={{
                        transition: "all 0.3s ease",
                        cursor: "pointer",
                      }}
                    >
                      <div className="d-flex flex-column">
                        <h6
                          className={`mb-2 ${
                            selectedSchedule?.id === schedule.id
                              ? "text-white"
                              : "text-primary"
                          }`}
                        >
                          {schedule.displayTitle || schedule.ptmTitle}
                        </h6>
                        <div className="small mb-2">
                          <i className="bi bi-calendar3 me-1"></i>
                          {new Date(schedule.eventDate).toLocaleDateString(
                            "en-US",
                            {
                              month: "short",
                              day: "numeric",
                              year: "numeric",
                            }
                          )}
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <span
                            className={`small ${
                              selectedSchedule?.id === schedule.id
                                ? "text-white-50"
                                : "text-muted"
                            }`}
                          >
                            {bookedCount}/{totalCount} slots
                          </span>
                          <span
                            className={`badge ${
                              selectedSchedule?.id === schedule.id
                                ? "bg-white text-black"
                                : "bg-light text-dark"
                            }`}
                          >
                            {percentage}%
                          </span>
                        </div>
                        <div className="progress" style={{ height: "3px" }}>
                          <div
                            className={`progress-bar ${getProgressColor(
                              percentage
                            )}`}
                            style={{ width: `${percentage}%` }}
                          />
                        </div>
                      </div>
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        {/* Main Content - Schedule Details */}
        <div className="col-lg-9">
          {selectedSchedule && (
            <div className="card shadow-sm border-0">
              <div className="card-header bg-gradient-primary text-white">
                <div className="row align-items-center">
                  <div className="col-md-8">
                    <h4 className="mb-1 text-white">
                      <i className="bi bi-person-workspace me-2"></i>
                      {selectedSchedule.teacherName}
                    </h4>
                    <div className="d-flex flex-wrap gap-3 mt-2">
                      <span className="small">
                        <i className="bi bi-book me-1"></i>
                        {selectedSchedule.classSectionName}
                      </span>
                      <span className="small">
                        <i className="bi bi-calendar-event me-1"></i>
                        {new Date(
                          selectedSchedule.eventDate
                        ).toLocaleDateString("en-US", {
                          weekday: "long",
                          month: "long",
                          day: "numeric",
                          year: "numeric",
                        })}
                      </span>
                    </div>
                  </div>
                  <div className="col-md-4 text-md-end mt-3 mt-md-0">
                    <div className="circular-progress">
                      <div className="progress-circle">
                        <span className="progress-text">
                          {bookedPercentage}%
                        </span>
                      </div>
                      <small className="d-block mt-1">Booked</small>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-body">
                {/* Stats Cards */}
                <div className="row mb-4">
                  <div className="col-md-4 mb-3">
                    <div className="stat-card bg-light-primary">
                      <div className="stat-icon">
                        <i className="bi bi-grid-3x3-gap text-primary"></i>
                      </div>
                      <div className="stat-content">
                        <h3 className="mb-0">
                          {selectedSchedule.schedule.length}
                        </h3>
                        <p className="mb-0 text-muted">Total Slots</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 mb-3">
                    <div className="stat-card bg-light-success">
                      <div className="stat-icon">
                        <i className="bi bi-check-circle text-success"></i>
                      </div>
                      <div className="stat-content">
                        <h3 className="mb-0">
                          {
                            selectedSchedule.schedule.filter(
                              (s) => s.status === "Booked"
                            ).length
                          }
                        </h3>
                        <p className="mb-0 text-muted">Booked</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 mb-3">
                    <div className="stat-card bg-light-info">
                      <div className="stat-icon">
                        <i className="bi bi-clock text-info"></i>
                      </div>
                      <div className="stat-content">
                        <h3 className="mb-0">
                          {
                            selectedSchedule.schedule.filter(
                              (s) => s.status === "Available"
                            ).length
                          }
                        </h3>
                        <p className="mb-0 text-muted">Available</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Schedule Timeline */}
                <h5 className="mb-3">
                  <i className="bi bi-clock-history me-2 text-primary"></i>
                  Schedule Timeline
                </h5>
                <div className="schedule-timeline">
                  <div className="table-responsive">
                    <table className="table table-hover align-middle">
                      <thead className="table-light">
                        <tr>
                          <th width="15%">
                            <i className="bi bi-clock me-1"></i>
                            Time
                          </th>
                          <th width="15%">Status</th>
                          <th width="35%">
                            <i className="bi bi-person me-1"></i>
                            Parent
                          </th>
                          <th width="35%">
                            <i className="bi bi-mortarboard me-1"></i>
                            Student
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedSchedule.schedule.map((slot, index) => (
                          <tr
                            key={index}
                            className={
                              slot.status === "Booked" ? "booked-slot" : ""
                            }
                          >
                            <td>
                              <span className="fw-bold time-slot">
                                {slot.slotTimeFormatted}
                              </span>
                            </td>
                            <td>{getSlotStatusBadge(slot.status)}</td>
                            <td>
                              {slot.status === "Booked" ? (
                                <div>
                                  <span className="text-dark fw-medium">
                                    {slot.parentName}
                                  </span>
                                </div>
                              ) : (
                                <span className="text-muted">—</span>
                              )}
                            </td>
                            <td>
                              {slot.status === "Booked" ? (
                                <div>
                                  <span className="text-dark fw-medium">
                                    {slot.studentName}
                                  </span>
                                </div>
                              ) : (
                                <span className="text-muted">—</span>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Appointments Cards */}
                {selectedSchedule.schedule.some(
                  (s) => s.status === "Booked"
                ) && (
                  <div className="mt-5">
                    <h5 className="mb-3">
                      <i className="bi bi-people me-2 text-primary"></i>
                      Confirmed Appointments
                    </h5>
                    <div className="row g-3">
                      {selectedSchedule.schedule
                        .filter((s) => s.status === "Booked")
                        .map((slot, index) => (
                          <div key={index} className="col-md-6 col-lg-4">
                            <div className="appointment-card">
                              <div className="appointment-time">
                                <i className="bi bi-clock-fill me-2"></i>
                                {slot.slotTimeFormatted}
                              </div>
                              <div className="appointment-details">
                                <div className="detail-row">
                                  <span className="detail-label">Parent:</span>
                                  <span className="detail-value">
                                    {slot.parentName}
                                  </span>
                                </div>
                                <div className="detail-row">
                                  <span className="detail-label">Student:</span>
                                  <span className="detail-value">
                                    {slot.studentName}
                                  </span>
                                </div>
                              </div>
                              <div className="appointment-number">
                                #{index + 1}
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                )}

                {selectedSchedule.schedule.every(
                  (s) => s.status === "Available"
                ) && (
                  <div className="alert alert-info mt-4">
                    <i className="bi bi-info-circle me-2"></i>
                    No appointments booked yet. Parents can book your available
                    slots through the parent portal.
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default PtmScheduleTeacher;
